import { BaseController } from '../../../common/base/controller';
import { DocumentTypeSelectables } from '../categorizeIncomingDocument/categorizeIncomingDocument.constants';

import _ from 'lodash';

export class DocumentListItemController extends BaseController {
  constructor(
    controllerService,
    $filter,
    inboxDocumentService
  ) {
    'ngInject';
    super({
      controllerService,
      $filter,
      inboxDocumentService
    });
  }

  get list() {
    return this.$filter('orderBy') (this.documents, this.order.by, this.order.reverse);
  }

  $onInit() {

  }

  isActive (jobId) {
    if (!this.inboxDocumentService.selectedDocument) {
      return false;
    }
    return this.inboxDocumentService.selectedDocument._id === jobId;
  }

  getTranslationKeyForFaxTyp(val) {
    return _.find(DocumentTypeSelectables.selectables, (e) => {
      return e.key === val;
    }).value;
  }
}
